import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { Footer as ExperimentFooter } from '../sunriseHoldoutExperiment/components/Footer';
import { useSunriseHoldoutExperiment } from '../sunriseHoldoutExperiment/hooks/useSunriseHoldoutExperiment';

export function Footer(): JSX.Element {
	const { enabled } = useSunriseHoldoutExperiment();

	if (enabled) {
		return <ExperimentFooter />;
	}

	return (
		<Box sx={{ textAlign: 'center', font: 'body' }}>
			<Text size="caption" data-qa="ppmu-modal-footer-text">
				<Translate value="corgi.co.ppmu.modal.footer_text" />
			</Text>
		</Box>
	);
}
